/* eslint-disable no-unused-vars */
import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import style from './tabs.module.scss';
import map from 'lodash-es/map';
import { Tab, Tabs } from '@mui/material';
import { TabsProps } from './tabs';
import { CategoryId } from 'store/types';

export default function FormTabs<T_val extends CategoryId>(
  props: TabsProps<T_val>
) {
  const { control } = useFormContext();

  return (
    <Controller
      name={props.groupName as `${string}`}
      control={control}
      defaultValue={props.defaultValue || 'Фотографии'}
      render={({ field }) => (
        <Tabs
          {...field}
          className={style.container}
          onChange={(event, newValue) => {
            field.onChange(newValue);
            props.onChange && props.onChange(event, newValue);
          }}
          textColor="primary"
          indicatorColor="primary"
        >
          {map(props.variants, (v) => {
            return <Tab value={v.id} label={v.text} key={v.id} />;
          })}
        </Tabs>
      )}
    ></Controller>
  );
}
